module.exports = __webpack_public_path__ + "img/19.20c668b9.jpg";